// extracted by mini-css-extract-plugin
export default {"UserList":"userList_UserList__aN9Bx"};